export const API_URL = "https://port-0-teamproject-server-p8xrq2mlfb8t8yh.sel3.cloudtype.app";
